
Checkout.Cart = function(checkout) {
	var cart = this;

	this.saved = true;
	this.items = {};
	this.listrakIndex = 1;
	this.listrakItemsString = "";
	this.shipping = new Checkout.Cart.Shipping(checkout, cart);
	this.totals = new Checkout.Cart.Totals(checkout, cart);
	this.shipping.init();

    this.Item = Checkout.Cart.Item;
	
	if (checkout.config.saveForLater) {
		this.savedItems = {};
		this.saveForLater = new Checkout.Cart.SaveForLater(checkout, cart);
		this.$savedWrap = $('#savedwrapper');
		this.$savedItemTpl = $('#saved-item-tpl');
		this.$savedContainer = $('#savedTableN');
	}

	this.$wrap = $('#scartwrapper');
	this.$anchor = $('a[name=cart]');
	this.$loadingOverlay = $('#cart-loading-overlay');
	this.$loadingMsg = this.$loadingOverlay.find('.msg-text');
	this.$emptyCart = $('#cart-empty');
	if (checkout.config.isEndeca) {
		this.$cartContentWrapper = $('.cartcontentwrapper');
	}
	this.$error = $('#cart-error');
	this.$errorMsg = this.$error.find('.msg-text');
	this.$warning = $('#cart-warning');
	this.$warningMsg = this.$warning.find('.msg-text');
	this.$itemTpl = $('#cart-item-tpl');
	this.$itemMoreInfoRowTpl = $('#cart-item-moreinfo-row-tpl');
	this.$itemContainer = $('#cartTableN');
	this.$linkToCart = $('#ltcart');
	this.$linkToCartTpl = $('#link-to-cart-tpl');
	this.$clearCart = $('#ccart');
	this.$textCart = $('#textcart');
	this.$sidebar = $('#cart-sidebar');
	this.$stepControls = $('#cart-step-controls');
	this.$proceed = $('#cart-proceed');
	this.$cShopping = this.$wrap.find('.cshopping');
	this.$addWishList = $("#addwishlist");
	this.$showSuggestions = $("#showSuggestions");
	this.$emailCart = $("#emailCart");
	this.$showEmailCart = $("#showEmailCart");
	this.$carSweepstakesBanner = $("#carSweepstakesBanner");
	this.$switchCheckout = $('#checkout-switch-select');
	this.shipETA = "";
	this.showShipOptionsETA = 0;

	this.init = function() {

		cart.listen();

		if (!checkout.session.get('step'))
			checkout.session.set({
				'step': 'cart'
			});

		// kick-off
		cart.getItems();
	};

	this.listen = function() {

		cart.$textCart.click(cart.showTextCart);

		cart.$clearCart.click(cart.clear);

		cart.$proceed.click(cart.proceed);

		cart.$addWishList.click(cart.addAllToWishList);
		
		cart.$cShopping.click(cart.continueShopping);

		cart.$showEmailCart.click(cart.showEmailCart);

        // hide popover title
		cart.$linkToCart.popover({
			title: '',
			placement: 'bottom',
			trigger: 'manual',
			html: true,
			content: function() {
				return cart.linkToCart();
			}
		})
		.click(function(e) {
			cart.toggleLinkToCart();
			//e.preventDefault();
			//return false;
		});
		/*
		// this doesn't work with bootstrap 4 
		.data(checkout.config.bsPopoverData).tip()
		.find('.popover-title')
		.hide();
		*/
		
		// cart-item event listeners (cloned when added)

		cart.$itemTpl.find('.cart-item-remove').click(function() {
			cart.getItemFromInput($(this))
				.remove();
		});

		cart.$itemTpl.find('.cart-item-qty')
			.bind('input propertychange', function() {
				var $el = $(this);

				checkout.delayChange($el, (Modernizr.touch ? 3000 : 2000), function() {
					$el.blur();
				});
			})
			.change(function() {
				var $el = $(this),
					item = cart.getItemFromInput($el),
					qty = (parseInt($el.val()) || 0);

				item.changeQty(qty);
			}).focus(function(){
				var myEsNum = $(this).parents('.prodNQty').siblings('.prodNDesc').find('.esnum').text().trim();
				if (myEsNum == '2710386' || myEsNum == '3047848') {
					$(this).siblings('.vgcTooltip').stop().fadeIn('fast', function(){
						var $this = $(this);
						$this.siblings('.cart-item-qty').animate({'background-color' : '#F54857'},300, function(){
							$this.delay(4000).fadeOut(1500, function(){
								$this.siblings('.cart-item-qty').animate({'background-color' : '#fff'},300);
							});
						});
					});
				}
			});
		cart.$itemTpl.find('.cart-item-remove-yes').click(function() {
			cart.getItemFromInput($(this))
				.confirmRemove(true);
		});

		cart.$itemTpl.find('.cart-item-remove-no').click(function() {
			cart.getItemFromInput($(this))
				.confirmRemove(false);
		});

		cart.$itemTpl.find('.cart-item-price-edit select').change(function() {
			cart.getItemFromInput($(this))
				.changePrice('select');
		});

		cart.$itemTpl.find('.cart-item-price-edit input')
			.bind('input propertychange', function() {
				var $el = $(this);

				checkout.delayChange($el, 1000, function() {
					$el.blur();
				});
			})
			.change(function() {
				cart.getItemFromInput($(this))
					.changePrice('input');
			});

		cart.$itemTpl.find('.cart-item-moreinfo-button').click(function() {
			cart.getItemFromInput($(this))
				.toggleMoreInfo();
		});

		cart.$switchCheckout.change( function(e) {
			checkout.switchCheckoutVersion( e.target.value );
		});
	};
	
	this.continueShopping = function(e) {
		
		e.preventDefault();

        var thisURL = new URL( window.location.href );
        var referrerURL = new URL( document.referrer );

        // make sure we don't send them to a different website
        if ( thisURL.hostname === referrerURL.hostname ) {
            window.location.href = referrerURL.toString();
        }
		
	};

	this.getItems = function() {

		cart.loading('Loading Cart Contents');
		return checkout.remote.call({
			'data': {
				'step': 'cart',
				'action': 'getItems',
				'options': encodeURIComponent(JSON.stringify( { 'isV2Checkout': checkout.config.isV2Checkout } )),
			}
		})
			.done(function(response) {
				$.each(response.data, function(i, itemResponse) {
					var cartItem = new cart.Item( checkout, cart );
                    cartItem.add( itemResponse );
				});

				if (response.warning.length)
					cart.error(response.warning.join('<br />'))

				if (response.notice.length)
					cart.error(response.notice.join('<br />'))

				if (Object.keys(cart.items).length){

					cart.toggleHasContents(true);
					cart.loading(false);
					cart.totals.calc(true);

					checkout.suggestions.show();
					
					seenSuggestions = true;
					
					if (checkout.config.shipDate.enabled) {
						cart.setShipDate(response);
					}
          
				} else {
					cart.toggleHasContents(false);
					cart.loading(false);
				}

                cart.sendToListrak();
			})
			.fail(function(request) {
				var errorMsg = checkout.remote.getErrorMsg(request);

				if (errorMsg) {
					cart.toggleHasContents(false);
					cart.loading(false);
					cart.error('Retrieving Cart Contents Failed');
				}

				$("#shipFloatText b").html([
                    '<br>There was an error processing your order ETA.<br> <br>',
                    'Please refresh the page or contact ',
                    '<a style="color:#b60209; cursor:pointer; background: none; border: 0;display: inline; margin-right: 0; padding:0 ;position: relative;transition:none;width:auto;" ',
                        ' href="mailto:' + checkout.config.contactInfo.email + '">',
                        checkout.config.contactInfo.email,
                    '</a>',
                ].join(''));

			});
	};

    this.checkAutoWishList = function() {
        if(window.location.search.match(/\batwl=1\b/)) cart.$addWishList.click();
    };

	// Show the Email My Cart modal
	this.showEmailCart = function(e) {
		console.log('showEmailCart');
		// without this the google recaptcha will not work in a bootstrap modal in IE 8-11
		// bootstrap modal's enforceFocus function prevents focusing on the recaptcha in IE
		// see
		// https://jsfiddle.net/emilhem/Lgovn28f/2/ a jsfiddle showing the issue
		// http://stackoverflow.com/a/28965638 stackoverflow answer with the code below
		// http://fiddle.jshell.net/Lgovn28f/10/ jsfiddle from above edited with the code from
		// stackoverflow, which now works
		if (e)
			e.preventDefault();
		$.fn.modal.Constructor.prototype.enforceFocus = function () { };
		if ( checkout.session.isLoggedIn() ) {
			var emailAddress = checkout.session.get('billing.email');
			cart.$emailCart.find("#targetEmail").val(emailAddress);

			cart.$emailCart.find('#ca-div').hide();
		} else {
			cart.$emailCart.find('#ca-div').show();
		}
		grecaptcha.reset();
		cart.$emailCart.modal("show");
	}
	this.$emailCart.find('#ca').click( function(e) {
		var caClicked = cart.$emailCart.find("#ca:checked").length;
		if (caClicked == 1)
			cart.$emailCart.find('#newaccountdetails').show();
		else
			cart.$emailCart.find('#newaccountdetails').hide();
	});
	this.$emailCart.find( ".js-email-cart-recaptcha-token" ).click(function(e) {
		e.preventDefault();
		$("#sendingEmailProgress").show();

		var err = validateEmailCart(cart.$emailCart);

		if ( err ) {
			$("#sendingEmailErrorMsg").html(err);
			$("#sendingEmailProgress").hide();
			return false;
		}
		var emailCartData = {
			'step'			: 'cart',
			'action'		: 'emailCart',
			'email'			: cart.$emailCart.find("#targetEmail").val().trim(),
			'password'	: cart.$emailCart.find('#targetPassword').val().trim(),
			'zip'				: cart.$emailCart.find('#targetZip').val().trim(),
			'ca' 				: cart.$emailCart.find("#ca:checked").length,
			'response' 	: $('#g-recaptcha-response').val().trim(),
		};

		if (checkout.user) {
			emailCartData.user = checkout.user;
		}

		checkout.remote.call({
			'data': emailCartData
		})
			.done(function(response) {
				cart.$emailCart.modal("hide");
				// reset fields
				$("#sendingEmailProgress").hide();
				$("#sendingEmailErrorMsg").html('');
				$('#ca').attr('checked', false );
				$('#targetPassword').val('');
				$('#targetZip').val('');
				$('#newaccountdetails').hide();
				$(window).unbind('beforeunload');
			})
			.fail(function(request) {
				var errorMsg = checkout.remote.getErrorMsg(request);

				$("#sendingEmailProgress").hide();

				if (errorMsg) {
					$("#sendingEmailErrorMsg").html(errorMsg);
					grecaptcha.reset();
				}
			});
	});

	this.$emailCart.find(".close").click(function(e) {
		$("#sendingEmailProgress").hide();
		$("#sendingEmailErrorMsg").html('');
		$('#ca').attr('checked', false );
		$('#targetPassword').val('');
		$('#targetZip').val('');
		$('#newaccountdetails').hide();
	});

	// Show the text cart page.
	// This will build a JSON object with all of the data needed to populate the text cart page.  The JSON object
	// will be passed as a URL parameter to the text cart page.
	this.showTextCart = function() {
		var cartItems = [];

		// Loop through the cart and get the product data for each item.
		$("#scartwrapper").find(".shoppingCartNList").each(function(i, obj) {
			var description = $(this).find(".cart-item-clean_description").html();
			var brand = $(this).find(".cart-item-brand").attr("alt");
			var shippingDisplay = $(this).find(".cart-item-shipfree").css('display');
			var freeShipping = "Free Shipping";
			if(shippingDisplay == 'none') {
				freeShipping = "";
			}
			var shippingEligibleDisplay = $(this).find(".cart-item-shipFreeEligible").css('display');
			var freeShippingEligible = "Free Shipping";
			if(shippingEligibleDisplay == 'none' || typeof shippingEligibleDisplay == 'undefined') {
				freeShippingEligible = "";
			}

			var esNumber = $(this).find(".cart-item-productID").html();
			var partNumber = $(this).find(".cart-item-pretty_partnumber > a").text();
			var qty = $(this).find(".cart-item-qty").val();
			var unitPrice = $(this).find(".cart-item-price").html();
			var extPrice = $(this).find(".cart-item-extendprice").html();
			var $stockStatusEl = $(this).find(".cart-item-stockStatus");
			var inStock = '';
			if ($stockStatusEl.length) {
				inStock = $stockStatusEl.html();
			}

			// We only want the end of the message.
			inStock = inStock.replace("If Ordered Now, ","");
			if(inStock == 'Ships Today') {
				inStock = 'In Stock';
			}
			cartItems.push({description: description,
					   brand: brand,
					   freeShipping: freeShipping,
					   freeShippingEligible: freeShippingEligible,
					   esNumber: esNumber,
					   partNumber: partNumber,
					   qty: qty,
					   unitPrice: unitPrice,
					   extPrice: extPrice,
					   inStock: inStock});
		});

		// Get the values from the cart totals section.
		var subTotal = $("span#cart-subtotal").html();
		var shipping = $("span#cart-shipping").html();
		var salesTax = $("span#cart-tax").html();
		var cartTotal = $("span#cart-total").html();
		// Remove the $ from cartTotal
		cartTotal = cartTotal.replace("$","");
		var taxExempt = $("#cart-tax-exempt").is(":checked");

		var totals = {subTotal: subTotal,
					  shipping: shipping,
					  salesTax: salesTax,
					  cartTotal: cartTotal,
					  taxExempt: taxExempt};

		// Build the link to the cart.
		var link = {linkToCart: cart.buildLinkToCart()};

		var parms = {cart: cartItems,
					 totals: totals,
					 link: link};

		// Format the URL parameter, create a form and submit it.
		var parameters="?parms="+encodeURIComponent(JSON.stringify(parms));
		var form = document.createElement('form');

		var formInput = '<input type="hidden" value="" id="parameters" name="parameters"></input>';

		// Workaround for Cross-Site Request Forgery
		if(typeof csrfParamName !== 'undefined') {
			formInput += '<input type="hidden" name="' + csrfParamName + '" value="' + csrfID + '" ></input>';
		}

		form.innerHTML = formInput;
		document.body.appendChild(form);
		$("#parameters").val(encodeURIComponent(JSON.stringify(parms)));
		form.method = "post";
		form.action = fixNavState("/Cart/Text/");
		form.submit();
	};

	// called after customer login
	this.checkItems = function(updateCart, qtyChanged) {

		cart.loading('Updating Cart Contents');
		cart.totals.loading('Updating Cart Contents');

		return checkout.remote.call({
			'data': {
				'step': 'cart',
				'action': 'getItems',
				'options': encodeURIComponent(JSON.stringify( { 'isV2Checkout': checkout.config.isV2Checkout } )),
			}
		})
		.done(function(response) {
			cart.updateItems(response);
			if (checkout.config.shipDate.enabled) {
				cart.setShipDate(response);
			}
			if (updateCart) {
				if (qtyChanged) {
					cart.totals.calc(true);
				} else {
					cart.totals.update('cart');
				}
			}
		})
		.always(function() {
			cart.loading(false);
		})
		.fail(function() {
			if (checkout.config.shipDate.enabled) {
				$(checkout.config.shipDate.target).html("There was an error processing your order ETA. Please refresh the page or contact <a href='"+checkout.config.contactInfo.email+"'>"+checkout.config.contactInfo.email+"</a>");
			}
		});
	};

    this.setShipDate = function(response) {
        var listETA=[];
        $.each(response.data, function(i, itemResponse) {
            listETA.push(itemResponse.item.ETA);
        });
        var latestETA;
        var latestIndex;
        var hasDirectShip = false;
        var backOrdered = false;
        listETA.forEach(function(myETA,i){
            if((!latestETA)||(myETA>latestETA)) {
                //ignore direct ship
                if(response.data[i].item.stockStatus!="Direct Ship") {
                    latestETA=myETA;
                    latestIndex = i;
                }
            }
            if(response.data[i].item.stockStatus=="Direct Ship") hasDirectShip=true;
            if(response.data[i].item.stockStatus.indexOf("Back Ordered")>=0) backOrdered=true;
        });
        var ETAmessage='';
        if(latestETA) {
			if (checkout.config.shipDate.enabled) {
				checkout.cart.shipETA = response.data[latestIndex].item.ETA;
				ETAmessage = isoDateFormatter(response.data[latestIndex].item.ETA);
			} else {
				ETAmessage = response.data[latestIndex].item.stockStatus;
			}
		}

        // strip to end of the message.
        ETAmessage = ETAmessage.replace("If Ordered Now, Ships","");

        if((!backOrdered)&&(latestETA)) {
			if (checkout.config.shipDate.enabled) {
            	$(checkout.config.shipDate.target).html("Your order is scheduled to ship on: <span id='shipETA' style='text-transform: uppercase;'></span>");
				$("#shipETA").append(ETAmessage);
			} else {
				$(checkout.config.shipDate.target).html("Your current projected ship date is <span id = \"shipETA\"></span> We only ship complete orders.");
            	$("#shipETA").append(ETAmessage+".");
			}
        }
        else {
            $(checkout.config.shipDate.target).html("<span id = \"shipETA\"></span> We only ship complete orders.");
            $("#shipETA").append("<span> Back Ordered items: Product ETA Unknown.  </span>");
        }
        if(hasDirectShip) {
            if(!latestETA) {
                $(checkout.config.shipDate.target).html("<span id = \"shipETA\"></span> We only ship complete orders.");
            }
            $("#shipETA").append("<span> Direct Ship from supplier: ETA will vary.  </span>");
        }
    };

	this.updateItems = function(response, warningMsg) {
		var scrollToCart = false;

		$.each(response.data, function(i, itemResponse) {

			if (itemResponse.infos.length)
				scrollToCart = true;

			var item = cart.items[itemResponse.item.cartItemKey];

			if (item)
				item.update(itemResponse.item, itemResponse.infos);
			else
				new cart.Item(checkout, cart).add(itemResponse);

		});

		if (response.warning.length) {
			scrollToCart = true;
			cart.error(response.warning.join('<br />'))
		}

		if (response.notice.length) {
			scrollToCart = true;
			cart.error(response.notice.join('<br />'))
		}

		if (warningMsg) {
			scrollToCart = true;
			cart.warning(warningMsg);
		}

		if (scrollToCart) {
			cart.totals.calc(true);
			$('html,body').animate(
				{ 'scrollTop': checkout.cart.$anchor.offset().top },
				500
			);
		} else {
			cart.totals.update('cart');
		}
	};

	this.clear = function() {

		cart.error(false);
		cart.warning(false);
		cart.loading('Clearing Cart Contents');

		checkout.remote.call({
			'data': {
				'step': 'cart',
				'action': 'clear'
			}
		})
			.done(function() {
				cart.items = {};
				cart.toggleStepControls();
				cart.$cShopping.hide();
				$('.topBmlBtn').hide();
				cart.toggleHasContents(false);
				cart.totals.updateNumItems();
				cart.$itemContainer.find('.shoppingCartNList').remove();
                cart.sendToListrak();
			})
			.fail(function(request) {
				var errorMsg = checkout.remote.getErrorMsg(request);
				alert('Error clearing cart contents' + ((errorMsg) ? ': '+errorMsg : ''));
			})
			.always(function() {
				cart.loading(false);
			});

	};

	this.toggleHasContents = function(hasContents) {
		if (hasContents) {
			cart.$linkToCart.show();
			cart.$clearCart.show();
			cart.$itemContainer.show();
			cart.$sidebar.show();
			cart.$emptyCart.hide();
			if (checkout.config.isEndeca) {
				cart.$cartContentWrapper.show();
			}
			cart.$cShopping.show();
			cart.$addWishList.show();
            cart.$carSweepstakesBanner.show();

            cart.checkAutoWishList();

			if (checkout.user)
				cart.$textCart.show();

		} else {

			checkout.session.set({
				'step': 'cart',
				'shippingOverride': null,
				'shippingOverrideAmt': null,
				'taxExempt': null,
				'alt_ship_notes': null
			});

			cart.$linkToCart.hide();
			cart.$clearCart.hide();
			cart.$textCart.hide();
			cart.$itemContainer.hide();
			cart.$sidebar.hide();
			cart.$emptyCart.show();
			if (checkout.config.isEndeca) {
				cart.$cartContentWrapper.hide();
			}
			cart.$cShopping.hide();
			$('.topBmlBtn').hide();
			cart.$addWishList.hide();
			$(window).unbind('beforeunload');
            cart.$carSweepstakesBanner.hide();

			if (checkout.shipping)
				checkout.shipping.$wrap.hide();

			if (checkout.login && checkout.login.$wrap)
				checkout.login.$wrap.hide();

			if (checkout.billship && checkout.billship.$wrap)
				checkout.billship.$wrap.hide();

			if (checkout.payment)
				checkout.payment.hide();
		}
	};

	this.loading = function(loadingMsg) {
		if (loadingMsg) {
			cart.$loadingMsg.html(loadingMsg);
			cart.$loadingOverlay.show();
			checkout.alignMiddle(cart.$loadingOverlay.find('.msg'), cart.$loadingOverlay);
			this.clearMessages();
		} else
			cart.$loadingOverlay.hide();
	};

	this.error = function(errorMsg) {
		if (errorMsg) {
			var currentMsg = cart.$errorMsg.html();

			if (currentMsg)
				cart.$errorMsg.html(this.cleanMessages(currentMsg, '<br />', errorMsg));
			else
				cart.$errorMsg.html(errorMsg);

			cart.$error.show();

		} else {
			cart.$error.hide();
			cart.$errorMsg.html('');
		}
	}

	this.warning = function(warningMsg) {
		if (warningMsg) {
			var currentMsg = cart.$warningMsg.html();

			if (currentMsg)
				cart.$warningMsg.html(this.cleanMessages(currentMsg, '<br />', warningMsg));
			else
				cart.$warningMsg.html(warningMsg);

			cart.$warning.show();

		} else {
			cart.$warning.hide();
			cart.$warningMsg.html('');
		}
	}

	this.linkToCart = function() {

		cart.$linkToCartTpl.find('textarea').html(cart.buildLinkToCart());

		return cart.$linkToCartTpl.html();
	};

	this.buildLinkToCart = function() {

		var queryParts = [];

		var i = 1;
		for (var cartItemKey in cart.items) {
			queryParts.push(
				'add'+i+'=' + cart.items[cartItemKey].data.productID,
				'qty'+i+'=' + cart.items[cartItemKey].data.qty
			);
            if(cart.items[cartItemKey].data.pdk) {
                queryParts.push('pdk'+i+'='+cart.items[cartItemKey].data.pdk);
            }
			i++;
		}

		queryParts.push(
			'utm_source=' + checkout.user,
			'utm_medium=email',
			'utm_content=link2cart'
		);

		if (checkout.user)
			queryParts.push(
				'salesrep=' + checkout.user
			);

     return document.URL.split('/',3).join('/')
     + fixNavState('/Cart/') + '?'
     + queryParts.join('&');

	};

	this.toggleLinkToCart = function() {
		/* This code centers the link to cart popover under link to cart. .popover is a class associated with bootstrap.
		Unless the bootstraps behaviors are addressed after the scope is properly determined there is a risk affecting elements that are not intended to have the same behavior.
		Hence the localized targeting.  This is not ideal solution to this issue, but the best available solution at the moment. */
		var popoverWidth = cart.$linkToCart.siblings('.popover').width();
		var positionLeft = cart.$linkToCart.position().left;
		var positionTop = cart.$linkToCart.position().top;
		var height = cart.$linkToCart.outerHeight();
		var width = cart.$linkToCart.outerWidth();
		var targetCenter = (positionLeft + (width / 2) - 215 );
		var targetBottom = (positionTop + height);

        var $popover = cart.$linkToCart.data( checkout.config.bsPopoverData );
        var $tip;
        if( $popover.$tip ) $tip = $popover.$tip;
        else                $tip = $( $popover.getTipElement() );

		if ( $tip.prev().length)
			cart.$linkToCart.popover('hide');
		else {
			cart.$linkToCart.popover('show');
			if (checkout.config.isEndeca) {
				cart.$linkToCart.siblings('.popover').css('position','absolute');
				cart.$linkToCart.siblings('.popover').css('left', targetCenter );
				cart.$linkToCart.siblings('.popover').css('top', targetBottom );
			}

			var $textArea = $tip.find('textarea');

			$textArea
				.click(function() {
					$textArea.select();
				})
				.select();
		}
	};

	this.getItemData = function() {
		var data = {};

		for (var cartItemKey in cart.items)
			data[cartItemKey] = cart.items[cartItemKey].data.qty

		return data;
	};

    this.containsProductID = function(findProductID) {

        for (var cartItemKey in cart.items) {
            if (cart.items[cartItemKey].productID == findProductID) {
                return true;
            }
        }

        return false;
    }

	this.toggleStepControls = function(force) {

		// if force is applied, use it
		if (arguments.length) {
			if (force)
				return cart.$stepControls.show();
			else
				return cart.$stepControls.hide();
		}

		var show = true;

		if (!Object.keys(cart.items).length)
			show = false;
		else if (checkout.session.get('step') != 'cart')
			show = false;
		else if (
			cart.shipping
			&& cart.shipping.errorMsg
		)
			show = false;

		if (show)
			cart.$stepControls.show();
		else
			return cart.$stepControls.hide();

	}

	this.validate = function() {

		if (cart.shipping.getValidateErrors().length)
			return false;

		return true;
	};

	this.proceed = function() {
		var errors = cart.shipping.getValidateErrors();

		if (errors.length)
			return cart.shipping.showValidateErrors(errors)

		cart.toggleStepControls(false);
		cart.$cShopping.hide();
		$('.topBmlBtn').hide();

		if (!checkout.shipping)
			checkout.shipping = new Checkout.Shipping(checkout);

		checkout.shipping.buildContent();
		checkout.shipping.stepTo();
	};

	this.addAllToWishList = function() {
        // Add a hidden "input.qty" for each item so that they
        // will be picked up by findQtys()

    	var pdkQtys = {};

        $(".cart-item-content:visible").each(function() {
            var productID = $(this).find(".cart-item-productID").html();
            var qty = $(this).find(".cart-item-qty").val().replace(/\D/, "");
            var pdk = $(this).find(".cart-item-pdk").html();
			var obj = {};

            try {
                qty = parseInt(qty, 10);
            }
            catch(e) {
                return;
            }
    
            if(qty > 0) {
    
                if(! pdkQtys[productID]) pdkQtys[productID] = new Array();
    			obj.pdk = pdk;
    			obj.qty = qty;
            }
    		pdkQtys[productID].push(obj);
        });

		window.getWishListProds = function() {
			return pdkQtys;
		}

        addToWishList();
    }

    this._sendToListrak = function() {
        if(typeof _ltk == "undefined") return;

        // if there isn't anything in the cart, clear it
        var itemCount = Object.keys( this.items ).length;
        if(itemCount == 0) {
            this.listrakItemsString = "";
            _ltk.SCA.ClearCart();
            return;
        }

        // Get the first part of the URL, without the path
        var baseURL = window.location.href.split('/')[ 2 ];

        // otherwise send the contents to listrak
        var queryParts = [];
        var i = 0;

        var listrakItems = [];

        $.each(this.items, function(cartitemID, item) {
            var imageURL = CDNpath + '/img/bg_no-image_100x75.jpg';
            if(item.data.mainImage) {
                imageURL = CDNproduct + '/' + item.data.mainImage + '_x300.jpg';
            }

            // Add the default product landing page
            var productURL = item.data.canonicalPath;

            /*
             * _ltk.SCA.AddItemWithLinks('<productID>', <quantity>,
             *                           '<price>', '<productName>',
             *                           '<productImageUrl>', '<productUrl>')
            */
            _ltk.SCA.AddItemWithLinks(
                item.data.pretty_partnumber,
                item.data.qty,
                item.data.availablePricing.retail,
                item.data.clean_description,
                imageURL,
                productURL /* , 😢 */
            );

            listrakItems.push([ 
                item.data.qty,
                item.data.availablePricing.retail,
                item.data.clean_description,
                imageURL,
                productURL 
            ]);

            ++ i;
            queryParts.push( "add" + i + "=" + item.data.productID );
            queryParts.push( "qty" + i + "=" + item.data.qty );
            if(item.data.pdk) {
                queryParts.push( "pdk" + i + "=" + item.data.pdk );
            }
        });
        var queryString = queryParts.join("&");
        var listrakItemsString = JSON.stringify( listrakItems );
        if (listrakItemsString == this.listrakItemsString) {
            _ltk.SCA.Reset();
            return;
        }
        this.listrakItemsString = listrakItemsString;
        _ltk.SCA.CartLink = baseURL + "/Cart/?" + queryString;
        _ltk.SCA.Submit();
    };

    /* use listrak's async manager to keep multiple 
       instances of _sendToListrak from running simultaneously,
       queue them up, make them dependent on the previous
       iteration completing */
    this.sendToListrak = function() {
        if(typeof _ltk == "undefined") return;
        if(typeof _ltk_util == "undefined") return;

        // default waitFors for an ltk_util.reeady call
        var waitFor = ["jQuery","_ltk","sessionLoad"];
        var ltkIndex = this.listrakIndex++;
        // wait for all of listrak's currently queued tasks, as well as the ones
        // we added to the queue
        _ltk_util.AsyncManager.Calls.forEach(function(call) {
            waitFor.push(call.Name);
        });
        // LTK Util AsyncManager.StartAsyncCall( name, function, timeout, async calls to wait for );
        _ltk_util.AsyncManager.StartAsyncCall( "_checkout_submit_"+ltkIndex, function() { 
            checkout.cart._sendToListrak();
        }, null, waitFor );
    };


	// Util
	this.getItemFromInput = function($el) {
		var cartItemKey = $el.parents('.shoppingCartNList').attr('id').replace('cart-item-', '');
		return cart.items[cartItemKey];
	};
	
	this.getSavedItemFromInput = function($el) {
		var savedItemKey = $el.parents('.savedCartNList').attr('id').replace('saved-item-', '');
		return cart.savedItems[savedItemKey];
	};
	
	this.clearMessages = function() {
		this.error();
		this.warning();
	}
	
	this.cleanMessages = function(oldMsgStr, separator, newMsg) { // return unique messages
		var hashSet = {};
		oldMsgStr.split(separator).forEach(function (msg){
			if (!(hashSet[msg])) {
				hashSet[msg] = true;
			}
		});
		if (!(hashSet[newMsg])) {
			hashSet[newMsg] = true;
		}
		return Object.keys(hashSet).join(separator);
	}

	this.init();
};
